import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createForOfIteratorHelper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
var mapCache = new Map();
export var deriveMapCache = {
  del: function del(key) {
    mapCache.delete(key);
  },
  forEach: function forEach(cb) {
    var _iterator = _createForOfIteratorHelper(mapCache.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            k = _step$value[0],
            v = _step$value[1];

        cb(k, v);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  get: function get(key) {
    return mapCache.get(key);
  },
  set: function set(key, value) {
    mapCache.set(key, value);
  }
};
export var deriveNoopCache = {
  del: function del() {
    return undefined;
  },
  forEach: function forEach() {
    return undefined;
  },
  get: function get() {
    return undefined;
  },
  set: function set(_, value) {
    return value;
  }
};